import ApiClient from './ApiClient';

class DealNotes extends ApiClient {
  constructor() {
    super('notes', { accountScoped: true });
    this.dealId = null;
  }

  get url() {
    return `${this.baseUrl()}/deals/${this.dealId}/notes`;
  }

  get(dealId) {
    this.dealId = dealId;
    return super.get();
  }

  create(dealId, content) {
    this.dealId = dealId;
    return super.create({ content });
  }

  delete(dealId, id) {
    this.dealId = dealId;
    return super.delete(id);
  }
}

export default new DealNotes();
